module.exports = "/_next/static/images/400-a571b64e4b7c5a1afadb2a2789d8d9b0.png";